var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    height: 145,
    width: 110,
    x: 0,
    y: 0,
    viewBox: "0 0 110 145",
    id: "svg1468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata17"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36,-18.5)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78306,0,0,0.78306,-447.41,-120.69)",
    id: "g2298"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 180.36,
    width: 110,
    height: 146,
    style: {
      fill: "#ffffff",
      stroke: "#666666",
      strokeWidth: 3.75,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect2296"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634,
    y: 198.36,
    width: 110,
    height: 146,
    style: {
      fill: "#ffffff",
      stroke: "#666666",
      strokeWidth: 3.75,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect2294"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 214.36,
    width: 110,
    height: 146,
    style: {
      fill: "#ffffff",
      stroke: "#666666",
      strokeWidth: 3.75,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect2280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,258.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,278.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,298.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,318.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,338.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.25,238.36 h 77.5",
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2.61350012
    },
    id: "path2292"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/papers.31f7d124a2c8b74bc755727b3d945f59.svg";
export { ForwardRef as ReactComponent };